import React, { useState, useEffect } from 'react';
import { graphql, useStaticQuery, Link } from 'gatsby';

import { storeLocale, getLangCode } from '../functions/localeUtils';
import { usePageId } from '../hooks/usePageId';
import { usePageLocale } from '../hooks/usePageLocale';
import { useLocales } from '../hooks/useLocales';

import { GlobeAsiaAustraliaIcon } from '@heroicons/react/24/outline';

export const LanguageSwitcher = () => {
    const data = useStaticQuery(graphql`
      query LanguageSwitcherQuery {
        allSitePage {
          pageNodes: nodes {
            path
            pageContext
          }
        }
      }
    `);
  
    const {
      allSitePage: { pageNodes },
    } = data;
  
    const { pageId } = usePageId();
    const { pageLocale } = usePageLocale();
    const { defaultLocale, locales } = useLocales();
  
    const getPathMatch = (renderingLocale) => {
      let path;
  
      const pageContextMatch = pageNodes.find(
        ({ pageContext: { id, locale } }) =>
          id === pageId && locale === renderingLocale
      );
  
      path = pageContextMatch?.path;
  
      if (!path) {
        const blogPathMatch = blogRootNodes.find(
          ({ locale }) => locale === renderingLocale
        );
        const { slug: blogPathSlug, locale: blogPathLocale } = blogPathMatch;
        const isRenderingDefaultLang = blogPathLocale === defaultLocale;
        if (isRenderingDefaultLang) {
          path = `/${blogPathSlug}`;
        } else path = `/${blogPathLocale}/${blogPathSlug}`;
      }
  
      return path;
    };
  
    const [color, setColor] = useState(false)

    const changeColor = () => {
      console.log(window.scrollY)
      if (window.scrollY >= 10) {
        setColor(true)
      } else {
        setColor(false)
      }
    }
    useEffect(() => {
      changeColor()
      window.addEventListener('scroll', changeColor)
    })

    return (
      <div className='LanguageSwitcherDropdown'>
        <a className={color ? 'LanguageSwitcherActiveDark': 'LanguageSwitcherActive'}>
          <GlobeAsiaAustraliaIcon className='LanguageSwitcherIcon' />
        </a>
        <div className='LanguageSwitcherMenu'>
          {locales.map((locale) =>
                locale === pageLocale ? (
                  <div key={locale}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <Link className='LanguageSwitcherLocales LanguageSwitcherLocales__nonActive'>
                      {getLangCode(locale)}
                    </Link>
                  </div>
                ) : (
                  <div key={locale}>
                    <Link
                      className='LanguageSwitcherLocales LanguageSwitcherLocales__Active'
                      to={getPathMatch(locale)}
                      onClick={() => storeLocale(locale)}
                    >
                      {getLangCode(locale)}
                    </Link>
                  </div>
                )
              )}
        </div>
      </div>
    );
  };
  